import i18n from '../../Configs/i18n';
import Cookies from 'js-cookie';
import AppConfig from '../../Configs/AppConfig';

const LANGUAGE_COOKIE_KEY = 'language';

const saveLanguageCookie = (lang: string): void => {
  Cookies.set(LANGUAGE_COOKIE_KEY, lang);
};

const getLanguageFromCookie = (): string | undefined => {
  return Cookies.get(LANGUAGE_COOKIE_KEY);
};

const getDefaultLanguage = (): string => AppConfig.LANG;

const setLangAttribute = (lang: string): void => {
  document.documentElement.setAttribute('lang', lang);
};

export const getInitLanguage = (): string => {
  const languageInCookie = getLanguageFromCookie();

  if (!languageInCookie) {
    const defaultLanguage = getDefaultLanguage();
    saveLanguageCookie(defaultLanguage);
    setLangAttribute(defaultLanguage);

    return defaultLanguage;
  }

  setLangAttribute(languageInCookie);
  return languageInCookie;
};

export const changeLanguage = (lang: string): void => {
  i18n.changeLanguage(lang);
  setLangAttribute(lang);
  saveLanguageCookie(lang);
};
